// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-field__title[data-v-7bf0eaae] {\n  font-size: 15px;\n}\n.preview[data-v-7bf0eaae] {\n  margin-bottom: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.file-preview[data-v-7bf0eaae] {\n  position: relative;\n}\n.file-preview__remove[data-v-7bf0eaae] {\n    position: absolute;\n    right: -30px;\n    top: -4px;\n}\n", ""]);
// Exports
module.exports = exports;
